<script>
    import R, {LOADER} from "../lib/requests";
    import user from "../stores/user";
    import Prompt from "../components/pages/Prompt.svelte";
    import Error from "../components/pages/Error.svelte";

    export let hash = null;

    let error = null;
    let success = null;

    const confirm = () => {

        const onSuccess = result => {
            user.setUser(result.data);
            if (result.action === 'create-account') {
                success = "Είστε πλέον συνδεμένοι στον λογαριασμό σας.|" +
                    "Εκκρεμεί η επαλήθευση των στοιχείων σας από την γραμματεία του Π.Κ.Σ.|" +
                "Μπορείτε να πραγματοποιείτε αγορές από το online κατάστημα του Π.Κ.Σ.";
            } else {
                success = "Είστε πλέον συνδεμένοι στον λογαριασμό σας.";
            }
        }

        const onFailure = err => {
            if (err.code === 'account_not_found') {
                error = `Ο λογαριασμός για την επαλήθευση στοιχείων δεν βρέθηκε!`;
            } else if (err.code === 'account_exist') {
                error = `Υπάρχει ήδη ένας λογαριασμός με το email "${err.params.email}".|Η εγγραφή σας δεν ολοκληρώθηκε!`;
            } else {
                error = "Το αίτημα δεν βρέθηκε ή το χρονικό όριο του αιτήματος έχει λήξει.";
            }
        };

        R.handle(R.action.confirm, hash, onSuccess, onFailure, LOADER.POPUP);
    }

    confirm();
</script>

<div class="container">
    <div class="mb-5">
        <h1>Επαλήθευση λογαριασμού</h1>
        <div class="heading-separator"></div>
    </div>
    {#if error}
        <Error message="{ error }"/>
    {/if}
    {#if success}
        <Prompt title="Η διαδικασία επαλήθευσης ολοκληρώθηκε!" message="{ success }"/>
    {/if}
</div>